export default __webpack_public_path__ + "static/media/icn-home.921896bd.svg";